import { useEffect, useRef, useState } from 'react';
import { useReduxState } from 'hooks';
import { useFormApi } from 'informed';
import { EmojiData } from 'emoji-mart';
import { ReaderEmojiPicker } from 'components/reader/common';
import { TextArea } from '.';

import { TextAreaProps } from './TextArea';

interface Props {
  textAreaProps: Exclude<
    TextAreaProps,
    'onClick' | 'onKeyDown' | 'textAreaContainerRef'
  >;
}

const TextAreaWithEmoji = ({ textAreaProps }: Props) => {
  const formApi = useFormApi();

  const { theme } = useReduxState();

  const textAreaContainer = useRef<HTMLDivElement>(undefined);

  const [currentPosition, setCurrentPosition] = useState(0);

  useEffect(() => {
    return () => clearTimeout(currentPositionTimeout);
  }, []);

  const handleEmojiSelect = (emoji: EmojiData) => {
    let currentText: string = formApi.getValue(textAreaProps.field) || '';

    if (currentPosition < currentText.length)
      currentText = `${currentText.slice(0, currentPosition)}${
        emoji.colons
      }${currentText.slice(currentPosition)}`;
    else currentText += emoji.colons;

    formApi.setValue(textAreaProps.field, currentText);
  };

  let currentPositionTimeout = null;
  const handleUpdateCurrentPosition = (
    ev: React.KeyboardEvent | React.MouseEvent
  ) => {
    if (ev) {
      clearTimeout(currentPositionTimeout);

      const target = ev.target as HTMLTextAreaElement;
      currentPositionTimeout = setTimeout(
        () => setCurrentPosition(target.selectionStart),
        1000
      );
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <TextArea
        onClick={handleUpdateCurrentPosition}
        onKeyDown={handleUpdateCurrentPosition}
        textareaContainerRef={(el: HTMLDivElement) =>
          (textAreaContainer.current = el)
        }
        {...textAreaProps}
      />

      <div style={{ position: 'absolute', bottom: -1, right: -8 }}>
        <ReaderEmojiPicker
          buttonColor={theme.textColorLighter}
          buttonColorActive={theme.textColor}
          disabled={false}
          onSelect={handleEmojiSelect}
        />
      </div>
    </div>
  );
};

export default TextAreaWithEmoji;
